import { render, staticRenderFns } from "./Lgx335766951898906624.vue?vue&type=template&id=3c3f947d&scoped=true&"
import script from "./Lgx335766951898906624.vue?vue&type=script&lang=js&"
export * from "./Lgx335766951898906624.vue?vue&type=script&lang=js&"
import style0 from "./Lgx335766951898906624.vue?vue&type=style&index=0&id=3c3f947d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3f947d",
  null
  
)

export default component.exports